<template>
  <div class="job" v-infinite-scroll="getProductsByJobType" infinite-scroll-disabled="busy" infinite-scroll-distance="150" infinite-scroll-root>
    <CustomizeHeader :title="title"></CustomizeHeader>
    <v-row class="py-1 ma-0">
      <v-col
        class="d-flex justify-center align-center" 
        style="padding: 6px"
        cols="6" 
        sm="4" 
        md="3" 
        lg="2" 
        xl="2" 
        v-for="product in products"
      >
        <v-hover
          v-slot:default="{ hover }"
        >
          <v-card 
            class="product-item" 
            :style="hover ? 'transform: scale(1.015)' : ''"
            :to="`/product/${product.id}`"
          >
            <div class="soldOut" v-if="product.sold > 0">售罄</div>
            <div :class="{sold: product.sold > 0}" style="width: 100%">
              <v-img :src="$func.productImagePreview(product)" aspect-ratio="1.75" />
              <div class="information">
                <v-avatar size="35" class="mr-2">
                  <v-img :src="$HOST_URL + product.usericon"/>
                </v-avatar>
                <v-col class="pa-0 rightInfo">
                  <div class="product-title text-ellipsis">{{ product.title }}</div>
                  <div class="d-flex align-center">
                    <v-icon color="grey">fa-eye</v-icon>
                    <span class="grey--text ml-1" >{{ product.views }}</span>
                  </div>
                </v-col>
              </div>
            </div>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CustomizeHeader from '@/components/CustomizeHeader'
export default {
  components: { CustomizeHeader },
  data() {
    return {
      products: [],
      busy: false,
      page: 1,
    }
  },
  watch: {
    title() {
      document.title = `${this.title} - ${this.$TITLE}`
    },

  },
  computed: {
    ...mapState('global', ['seller_job_types']),
    title() {
      if(this.seller_job_types.length > 0) {
        return this.seller_job_types.find(type => type.num == this.$route.params.id).name
      }
    }
  },
  methods: {
    getProductsByJobType() {
      this.busy = true
      this.axios.post('/products/condition', {
        search : [
          {table: 'sellers', column: 'job', keyword: [parseInt(this.$route.params.id), parseInt(this.$route.params.id)]},
          {table: 'products', column: 'product_type', keyword: 'clothes'}
        ],
        page: this.page,
        size: 50,
        includeSeller: true
      }).then(response => {
        this.products = this.products.concat(response.data.data)
        if(this.page != response.data.last_page) {
          this.page += 1  
          this.busy = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.job {
  .product-item {
    background-color: $grey-3;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .rightInfo {
      overflow: hidden;
    }
    .product-title {
      font-size: 14px;
    }
    .v-icon {
      font-size: 12px;
    }
    span {
      font-size: 12px;
    }
  }
}
</style>